module.exports = "#### Using the Helsinki Brand material\n\nPlease download the brand material "


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/routes/design/BrandMaterial/BrandMaterial.md
// module id = 226
// module chunks = 0